export const style = {
  payment: {
    display: `inline-block`,
    '::first-letter': {
      textTransform: `uppercase`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Transactions/style/main.js